import { FormValidator, ValidationResult } from '../formField/types/form-validator';

export const MaxValidator: (maxInclusive: number, errorMessage: string) => FormValidator = (
  maxInclusive: number,
  errorMessage: string
) => {
  return async (value: number): Promise<ValidationResult> => {
    if (isNaN(value) || value > maxInclusive) {
      return {
        valid: false,
        error: errorMessage,
      };
    }

    return { valid: true };
  };
};
